import React, { Component } from 'react';
import PropTypes from 'prop-types';
import OwlCarousel from 'react-owl-carousel';

export default class MapsItems extends Component {
  constructor(props) {
    super(props);
    this.state = {
      curPos: null,
      title: '',
    }
  }

  componentDidMount() {}

  render() {
    const settings = {
      className: 'owl-theme',
      margin: 25,
      items: 6,
      loop: false,
      nav: false,
      responsive : {
        0:{
          items:1
        },
        400:{
          items:2
        },
        600:{
          items:3
        },
        900:{
          items:4,
        },
        1100:{
          items:5,
        },
        1200:{
          items:6,
        }
      }
    };
    
    return (
      <OwlCarousel { ...settings } ref={inst => this._slider = inst}>
        {this.props.data.map((item,i) => {
          return (
            <div key={i} onClick={() => {
              this.props.openData(item);
            }} className="slide" style={{ 
              backgroundImage: `url(${item.thumb})`,
              cursor: 'pointer'
            }}></div>
          )
        })}
      </OwlCarousel>
    )
  }
}
MapsItems.defaultProps = {}

MapsItems.propTypes = {}


// WEBPACK FOOTER //
// ./src/components/MapsItems.js